// Cari hesap TÜRLERİ — tek liste (kullanıcı, 2026-10-13).
// Tür dört ekranda dört ayrı listeyle seçiliyordu ("Tedarikciler ve
// Musteriler", "Tedarikçiler ve Satıcılar", "Tedarikçi", "Müşteriler"...) ve
// liste süzgeci türü BİREBİR karşılaştırdığı için aynı türdeki cariler
// bölünüyordu. Sunucu kopyası `backend/hesap_turleri.py`: eski yazımı
// karşılığına çevirir, tanımadığını 400 ile reddeder — biri değişirse öteki de.
// "Personel" ve "Kasa ve Bankalar" adları kodda süzgeç olarak geçiyor,
// DEĞİŞTİRİLMEMELİ.
export const HESAP_TURLERI = [
  'Tedarikçiler ve Müşteriler',
  'Personel',
  'Vergi ve Harçlar',
  'Kasa ve Bankalar',
  'Ortaklar ve İştirakler',
  'Çek ve Senetler',
];

export const VARSAYILAN_HESAP_TURU = HESAP_TURLERI[0];

// Personel cari hesabı İK'dan (personel kartı), çek/senet hesapları çek
// ekranından kendiliğinden açılır; cari ekranlarında yeni hesap açarken seçilemez.
export const YENI_HESAP_TURLERI = HESAP_TURLERI.filter(t => t !== 'Personel' && t !== 'Çek ve Senetler');
